import { Action, configureStore } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import { createEpicMiddleware, Epic } from 'redux-observable';
import {
    ActivityLogClient,
    AgreementClient,
    AgreementPriceClient,
    ApplicationRestrictionsClient,
    CalculationClient,
    ContactClient,
    CostClient,
    CostGroupClient,
    CustomerClient,
    CustomerGroupClient,
    ExternalPriceClient,
    ExternalPricelistClient,
    OrganizationClient,
    PermissionClient,
    PriceClient,
    PricelistClient,
    PricelistCustomerClient,
    ProductCategoryClient,
    ProductClient,
    ProductGroupClient,
    SettingsClient,
    StockClient,
    UserClient,
    UserGroupClient,
    UserSettingsClient,
    WarehouseClient,
    TagClient,
    ExchangeRateClient
} from '../common/PricePrgClient';
import rootEpic from './rootEpic';
import rootReducer from './rootReducer';

const epicDependencies = {
    calcClient: new CalculationClient(),
    costClient: new CostClient(),
    costGroupClient: new CostGroupClient(),
    priceClient: new PriceClient(),
    pricelistClient: new PricelistClient(),
    stockClient: new StockClient(),
    productClient: new ProductClient(),
    productGroupClient: new ProductGroupClient(),
    productCategoryClient: new ProductCategoryClient(),
    userSettingsClient: new UserSettingsClient(),
    userClient: new UserClient(),
    userGroupClient: new UserGroupClient(),
    permissionClient: new PermissionClient(),
    externalPricelistClient: new ExternalPricelistClient(),
    customerClient: new CustomerClient(),
    externalPriceClient: new ExternalPriceClient(),
    agreementClient: new AgreementClient(),
    agreementPriceClient: new AgreementPriceClient(),
    warehouseClient: new WarehouseClient(),
    settingsClient: new SettingsClient(),
    customerGroupsClient: new CustomerGroupClient(),
    organizationClient: new OrganizationClient(),
    activityLogClient: new ActivityLogClient(),
    applicationSettingsClient: new ApplicationRestrictionsClient(),
    contactClient: new ContactClient(),
    pricelistCustomerClient: new PricelistCustomerClient(),
    tagClient: new TagClient(),
    exchangeRateClient: new ExchangeRateClient(),
    dispatch: (action: Action) => store.dispatch(action)
};
export type PricePrgDependencies = typeof epicDependencies;

export const epicMiddleware = createEpicMiddleware<Action, Action, RootState>({
    dependencies: epicDependencies
});

const middleWares = [epicMiddleware];

const store = configureStore({
    reducer: rootReducer,
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware({
            thunk: false,
            serializableCheck: false,
            immutableCheck: false
        }).concat(...middleWares)
});

epicMiddleware.run(rootEpic);

export default store;

export type RootState = ReturnType<typeof rootReducer>;
export type RootEpic = Epic<Action, Action, RootState, PricePrgDependencies>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
